export const STEPPER_BUTTON_STATUS = {
  DEFINE_AUDIENCE: 1,
  FINALIZE_AND_LAUNCH: 2,
  MAP_QUOTAS: 3,
};

export const SURVEY_PAGES = {
  AUDIENCE: 'AUDIENCE',
  MAP_QUOTA: 'MAP_QUOTA',
  LAUNCH: 'LAUNCH',
  SUPPLIER: 'SUPPLIER',
};
